import React from 'react';
import PropTypes from 'prop-types';
import css from './Confirmation.css';
import Time from '../review/Time';
import TeamMember from '../review/TeamMember';
import Location from '../review/Location';
import Reason from '../review/Reason';
import MeetingInstructions from '../review/MeetingInstructions';
import ChangeAppointmentLink from './ChangeAppointmentLink';
import ReturnLink from './ReturnLink';
import ViewAllUpcomingLink from './ViewAllUpcomingLink';
import Toast from 'common/Toast';
import Course from '../review/Course';
import StudentNote from './StudentNote';
import { SFEntityID } from 'utils/types';
import GroupSessionParticipants from "../review/GroupSessionParticipants";

export default class Confirmation extends React.Component {

  get teamMember() {
    if ( !this.props.displayTeamMember ) return null;
    return (
      <TeamMember
        name={this.props.ownerName}
        title={this.props.ownerTitle || (this.props.ownerRoles && this.props.ownerRoles.join(", "))}
        photoURL={this.props.ownerPhotoURL}
      />
    );
  }

  get courseDetails() {
    if(!this.props.courseName) return null;
    return  (
      <Course courseName={this.props.courseName}/>
    );
  }

  get studentNote() {
    if(!this.props.studentNote) return null;
    return  (
      <StudentNote studentNote={this.props.studentNote}/>
    );
  }

  get meetingInstructions() {
    if(!this.props.scheduleBlockInstructions) return null;
    return  (
      <MeetingInstructions instructions={this.props.scheduleBlockInstructions}/>
    );
  }

  render() {
    return (
      <div className={css['content']}>
        <div className={css['container']}>
          <div>
            <Time
              startDate={this.props.startDate}
              duration={this.props.duration}
              recurring={this.props.recurring}
              recurrenceLabel={this.props.recurrenceLabel}
              recurrenceEndDate={this.props.recurrenceEndDate}
            />
            {this.teamMember}
            <Location locationName={this.props.locationName} instructions={this.props.instructions} />
            {this.meetingInstructions}
            <GroupSessionParticipants participants={this.props.participants} />
            {this.courseDetails}
            {this.studentNote}
          </div>
          <div>
            <Reason name={this.props.reasonName} />
            <div><ChangeAppointmentLink appointmentId={this.props.appointmentId} /></div>
            <div><ReturnLink /></div>
            <div><ViewAllUpcomingLink /></div>
          </div>
        </div>
        <Toast message="Appointment confirmed" />
      </div>
    );
  }
}

Confirmation.propTypes = {
  appointmentId: SFEntityID.isRequired,
  startDate: PropTypes.object.isRequired,
  duration: PropTypes.number.isRequired,
  locationName: PropTypes.string.isRequired,
  instructions: PropTypes.string,
  reasonName: PropTypes.string.isRequired,
  displayTeamMember: PropTypes.bool,
  ownerName: PropTypes.string,
  ownerTitle: PropTypes.string,
  ownerRoles: PropTypes.array,
  ownerPhotoURL: PropTypes.string,
  recurring: PropTypes.bool,
  recurrenceLabel: PropTypes.string,
  recurrenceEndDate: PropTypes.object,
  courseName: PropTypes.string,
  studentNote: PropTypes.string,
  scheduleBlockInstructions: PropTypes.string,
  participants: PropTypes.array
};
